import React from 'react'
import { Menu, MenuItemProps } from 'antd'

export const MenuItem: React.FC<MenuItemProps> = props => (
  <Menu.Item {...props} />
)
